/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomebannerbody2Inputs */

const en_outcomebannerbody2 = /** @type {(inputs: Outcomebannerbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you send the letter, log how the contractor responded — it tells us when to nudge you toward the next step.`)
};

const pt_outcomebannerbody2 = /** @type {(inputs: Outcomebannerbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando enviar a carta, registe como o empreiteiro respondeu — assim sabemos quando o orientar para o passo seguinte.`)
};

/**
* | output |
* | --- |
* | "When you send the letter, log how the contractor responded — it tells us when to nudge you toward the next step." |
*
* @param {Outcomebannerbody2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomebannerbody2 = /** @type {((inputs?: Outcomebannerbody2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomebannerbody2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomebannerbody2(inputs)
	return pt_outcomebannerbody2(inputs)
});
export { outcomebannerbody2 as "outcomeBannerBody" }